import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import SiteFilterUI from "../ui/SiteFilterUI.vue";
import SiteFilterBadge from "../ui/badges/SiteFilterBadge.vue";

export default class SiteFilter implements EventFilter {
  constructor(
    public readonly siteId: number,
    public readonly isNegated?: boolean,
  ) {}

  static readonly UI = SiteFilterUI;
  static readonly Badge = SiteFilterBadge;

  getEventFilter(): FilterOption {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_SITE_ID,
        value: { value: [this.siteId], negated: this.isNegated ?? false },
      },
    };
  }
}
